export default __webpack_public_path__ + "static/eidas-badge-ef24df7d4bbb89b3681aab5b33e4556b.png";